// src/store/slices/preferencesSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

//
// 1) shape out each preference‐block
//
interface FeedbackPreferences {
  showMonthlyPrompt: boolean;
  showInitialPrompt: boolean;
}

//
// 2) top‐level preferences state; add new blocks here as needed
//
interface PreferencesState {
  feedback: FeedbackPreferences;
  // e.g. notifications: NotificationPreferences;
  //      theme: ThemePreferences;
}

const initialState: PreferencesState = {
  feedback: {
    showMonthlyPrompt: false,
    showInitialPrompt: false,
  },
};

const preferencesSlice = createSlice({
  name: 'preferences',
  initialState,
  reducers: {
    //
    // 3a) a generic updater for the whole feedback block
    //
    updateFeedbackPreferences(
      state,
      action: PayloadAction<Partial<FeedbackPreferences>>
    ) {
      state.feedback = { ...state.feedback, ...action.payload };
    },

    //
    // 3b) granular actions for just those two flags
    //
    setShowMonthlyPrompt(state, action: PayloadAction<boolean>) {
      state.feedback.showMonthlyPrompt = action.payload;
    },
    setShowInitialPrompt(state, action: PayloadAction<boolean>) {
      state.feedback.showInitialPrompt = action.payload;
    },
  },
});

export const {
  updateFeedbackPreferences,
  setShowMonthlyPrompt,
  setShowInitialPrompt,
} = preferencesSlice.actions;

export default preferencesSlice.reducer;
